<template>
  <div class="try-tutorial-popup">
    <b-modal
        id="try-tutorial-popup-modal"
        centered
        hide-footer
        hide-header
        no-close-on-backdrop
        content-class="model-content"
        body-class="model-body"
    >
      <SafetyPopup v-if="activePopupName === 'safety_popup'" @hideModal="hidePopup"></SafetyPopup>
      <TrySMBPopup v-else-if="activePopupName === 'smb_popup'" @hideModal="hidePopup"/>
      <TryDemoPopup v-else @hideModal="hidePopup"/>
    </b-modal>
  </div>
</template>
<script>
import TryDemoPopup from "./TryDemoPopup";
import TrySMBPopup from "./TrySMBPopup";
import SafetyPopup from "./SafetyPopup.vue";

export default {
  name: "TryPopup",
  components: {
    TryDemoPopup,
    TrySMBPopup,
    SafetyPopup,
  },
  data() {
    return {
      activePopupName: null,
      showPopupProcessId: null,
      allPopups: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isCorporateHR() {
      return this.userInfo.role && this.userInfo.role === "CorporateHR";
    },
    subscription() {
      return this.userInfo?.corporate?.subscription;
    },
    isPhysiotherapy() {
        return this.userInfo?.corporate?.theme === "physiotherapy";
    }
  },
  methods: {
    onStartShowing(popupToShow) {
        this.activePopupName = popupToShow.key;
        popupToShow.isShowing = true;
        this.$root.$emit('bv::show::modal', 'try-tutorial-popup-modal');
    },
    showNextPopup() {
        let lastShownPopupIndex = localStorage.getItem('lastShownPopup');
        lastShownPopupIndex = lastShownPopupIndex ? Number(lastShownPopupIndex):-1;
        const popupToShow = this.allPopups.find((popup, index) => index > lastShownPopupIndex && popup.needToShow && !popup.shown);

        if (!popupToShow) return;

        let path = this.$route.path;
        const allowedPaths = popupToShow.allowedPaths ?? [path];
        if (allowedPaths.some(p => p.match(path))) {
            if (popupToShow.isShowing) {
                console.log('Already showing');
                return;
            }
            const duration = popupToShow.duration;
            const delay = popupToShow.delay;

            if (delay) {
                const delayPID = setInterval(_ => {
                    if (!popupToShow.isShowing) {
                        this.onStartShowing(popupToShow);
                        if (duration) this.showPopupProcessId = setTimeout(this.hidePopup, duration)
                    }
                    clearInterval(delayPID);
                }, delay);
            } else {
                if (!popupToShow.isShowing) {
                    this.onStartShowing(popupToShow);
                    if (duration) this.showPopupProcessId = setTimeout(this.hidePopup, duration)
                }
            }
        }
    },
    hidePopup() {
        const popupToHide = this.allPopups.find(popup => popup.key === this.activePopupName);
        if (!popupToHide) return;
        if (['smb_popup', 'demo_popup'].includes(popupToHide.key)) this.$store.dispatch("disableTutorialPopup");

        popupToHide.isShowing = false;
        popupToHide.shown = true;
        this.$root.$emit('bv::hide::modal', 'try-tutorial-popup-modal');
        const index = this.allPopups.findIndex(popup => popup.key === popupToHide.key);
        localStorage.setItem('lastShownPopup', index);
    },
  },
  mounted() {
    const needToShowSmbPopup = !!(this.isPhysiotherapy && this.isCorporateHR && this.subscription?.allow_video_upload);
    this.allPopups = [
      {
        key: 'safety_popup', 
        needToShow: this.userInfo?.config?.showSafetyMessage ?? true, 
        shown: false, isShowing: false,
        allowedPaths: ['/user/main']
      },
      {
        key: 'smb_popup', 
        needToShow: needToShowSmbPopup, 
        isShowing: false,
        shown: this.$store.state.userInfo.disable_tutorial_popup ?? true, 
        allowedPaths: ['/user/main', '/user/discover'], duration: 10000, delay: 1000
      },
      {
        key: 'demo_popup', 
        needToShow: !needToShowSmbPopup, 
        isShowing: false,
        shown: this.$store.state.userInfo.disable_tutorial_popup ?? true, 
        allowedPaths: ['/user/main', '/user/discover'], duration: 10000, delay: 1000
      }
    ];

    this.showNextPopup();
  },
  beforeDestroy() {
    clearTimeout(this.showPopupProcessId);
  }
}
</script>
<style lang="scss" scoped>

::v-deep .modal-dialog-centered{
  height: 100dvh;
}
::v-deep .model-content {
  width: auto !important;
  margin: auto;
  background-color: #8DC63F !important;
  border: none !important;
  border-radius: 20px;
  @media screen and (max-width: 950px) {
      width: 80% !important; 
        
      @media (orientation: landscape) {
          max-height: 80vh !important;
      }
    }
  .model-body {
    padding: 0;
  }
}
</style>